import React from 'react'
import Box from '@mui/material/Box'
import styled from 'styled-components'
import Typography from '@mui/material/Typography'

import { ActionCardProps } from 'types/TextAnalysis'

const CaptionBox = styled(Box)({
  display: 'block',
  margin: '0 !important',
  paddingTop: '1rem',
})

const CardMetrics = React.memo(function CardMetrics({
  cardMetrics,
  cardMetricsVariant,
}: ActionCardProps) {
  if (!cardMetrics) return <></>
  return (
    <CaptionBox>
      <Typography
        variant={cardMetricsVariant}
        display="block"
        color="text.secondary"
      >
        {cardMetrics}
      </Typography>
    </CaptionBox>
  )
})

export { CardMetrics }
